<h3 class="harp-title mb-4">Here's how to contact us</h3>

<div class="row">
  <div class="col-3" *ngIf="hours || days">
    <div class="mb-3" *ngIf="hours">{{ hours }}</div>
    <div *ngIf="days">{{ days }}</div>
  </div>

  <div class="col-5" *ngIf="true">
    <div class="mb-3" *ngIf="email">
      Email: <a href="mailto:{{ email }}">{{ email }}</a>
    </div>
    <div class="mb-3" *ngIf="phone1">Phone: {{ phone1 }}</div>
    <div class="mb-3" *ngIf="phone2">Phone: {{ phone2 }}</div>
    <div class="mb-3" *ngIf="slack">Slack: {{ slack }}</div>
  </div>
</div>
